import React, { useState, useEffect } from "react";
import API from "../utils/apiCalling";
import Config from "../config/env";
import Loader from '../utils/loader';
import { useHistory } from "react-router-dom";

const LoginSignupForSurveyAttempt = (params) => {
    const [activeTab, setActiveTab] = useState("signup");
    const history = new useHistory()
    let api = new API();

    const [signupData, setSignupData] = useState({
        name: "",
        email: "",
        organizationName:""
    });

    const [loginIdentifier, setLoginIdentifier] = useState("");

    // OTP state
    const [showOtp, setShowOtp] = useState(false);
    const [otp, setOtp] = useState("");
    const [otpType, setOtpType] = useState("");

    // Loading
    const [loading, setLoading] = useState(false);

    // Message
    const [message, setMessage] = useState("");
    const [messageType, setMessageType] = useState("");

    // =========================================================
    // AFTER LOGIN
    // =========================================================

    const [showDashboard, setShowDashboard] = useState(false);

    const [auditorName, setAuditorName] = useState("");

    // =========================================================
    // TEMPORARY SURVEY DATA
    // Later you can replace this with API response
    // =========================================================

    const [surveyData, setSurveyData] = useState({
        ongoing: [
            {
                id: 1,
                title: "Customer Satisfaction Q3",
                company: "Nova Retail Pvt Ltd",
                endDate: "25 Aug 2026",
            },
            {
                id: 2,
                title: "Branch Experience Feedback",
                company: "BluePeak Bank",
                endDate: "30 Aug 2026",
            },
            {
                id: 3,
                title: "Network Quality Pulse Check",
                company: "Orbit Telecom",
                endDate: "02 Sep 2026",
            },
        ],

        saved: [],

        submitted: [],
    });
    const [activeDashboardTab, setActiveDashboardTab] = useState("ongoing");
    const [surveySearch, setSurveySearch] = useState("");

    // const filteredSurveys =
        // activeDashboardTab === "saved" || activeDashboardTab === "submitted"
        //     ? (surveyData[activeDashboardTab] || []).filter((survey) => {
        //           const search = surveySearch.trim().toLowerCase();

        //           if (!search) {
        //            return surveyData[activeDashboardTab]
        //             //   return true;
        //           }

        //           return survey.responseId
        //               ?.toString()
        //               .toLowerCase()
        //               .includes(search);
        //       })
        const filteredSurveys =
    activeDashboardTab === "saved" || activeDashboardTab === "submitted"
        ? (surveyData[activeDashboardTab] || []).filter((survey) => {
              const search = surveySearch.trim().toLowerCase();

              if (!search) {
                  return true;
              }

              // Search in responseId
              const responseIdMatch = survey.responseId
                  ?.toString()
                  .toLowerCase()
                  .includes(search);

              // Search in filterAnswer (string or array)
              const answer = survey.filterAnswer;

              const answerMatch = Array.isArray(answer)
                  ? answer.some((item) =>
                        item?.toString().toLowerCase().includes(search)
                    )
                  : answer
                      ?.toString()
                      .toLowerCase()
                      .includes(search);

              return responseIdMatch || answerMatch;
          })
        : surveyData.ongoing || [];

    console.log("Active Tab:", activeDashboardTab);
    console.log("Original List:", surveyData[activeDashboardTab]);
    console.log("Filtered Surveys:", filteredSurveys);

    // =========================================================
    // SIGNUP INPUT
    // =========================================================

    const handleSignupChange = (e) => {
        const { name, value } = e.target;

        setSignupData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // =========================================================
    // SIGNUP - SEND OTP
    // =========================================================

    const handleSignupSubmit = async (e) => {
        e.preventDefault();

        setMessage("");
        setLoading(true);

        try {
            const email = signupData.email.trim().toLowerCase();

            const result = await api.post(
                `${Config.new.site_api}/survey/createNewSurveyAuditor`,
                {
                    name: signupData.name.trim(),
                    email: email,
                    organizationName:signupData.organizationName,
                }
            );

            console.log("Signup OTP response:", result);

            if (result?.error === false && result?.code === 200) {
                setSignupData((prev) => ({
                    ...prev,
                    email: email,
                }));

                setOtp("");
                setOtpType("signup");
                setShowOtp(true);

                setMessage("OTP sent successfully to your email.");
                setMessageType("success");
            } else {
                setMessage(
                    result?.message ||
                    "Unable to send OTP. Please try again."
                );
                setMessageType("error");
            }
        } catch (error) {
            console.error("Signup OTP error:", error);

            setMessage(
                error?.response?.message ||
                "Something went wrong while sending OTP."
            );

            setMessageType("error");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const storedAuditor =
            localStorage.getItem("surveyAuditor");

        if (storedAuditor) {

            const parsedAuditor =
                JSON.parse(storedAuditor);

            if (parsedAuditor) {

                console.log(
                    "Already logged in auditor:",
                    parsedAuditor
                );


                const loggedInName =
                    parsedAuditor?.name ||
                    parsedAuditor?.auditor_name ||
                    parsedAuditor?.first_name ||
                    signupData.name ||
                    "Auditor";

                setAuditorName(loggedInName);

                setShowOtp(false);
                setOtp("");

                setShowDashboard(true);
                fetchSurveys("ongoing");
                setMessage("");
                setMessageType("");

            }
        }
    }, [])

    // =========================================================
    // LOGIN - SEND OTP
    // =========================================================

    const handleLoginSubmit = async (e) => {
        e.preventDefault();

        setMessage("");
        setLoading(true);

        try {
            const email = loginIdentifier.trim().toLowerCase();

            const result = await api.post(
                `${Config.new.site_api}/survey/sendOtpLoginSurveyAuditor`,
                {
                    email: email,
                }
            );

            console.log("Login OTP response:", result);

            if (result?.error === false && result?.code === 200) {
                setLoginIdentifier(email);

                setOtp("");
                setOtpType("login");
                setShowOtp(true);
                localStorage.setItem("surveyAuditor", JSON.stringify(result.data))
                setMessage("OTP sent successfully to your email.");
                setMessageType("success");
            } else {
                setMessage(
                    result?.message ||
                    "Unable to send OTP. Please check your email."
                );

                setMessageType("error");
            }
        } catch (error) {
            console.error("Login OTP error:", error);

            setMessage(
                error?.response?.message ||
                "Something went wrong while sending OTP."
            );

            setMessageType("error");
        } finally {
            setLoading(false);
        }
    };

    // =========================================================
    // OTP INPUT
    // =========================================================

    const handleOtpChange = (e) => {
        const value = e.target.value.replace(/\D/g, "");

        if (value.length <= 6) {
            setOtp(value);
        }
    };

    // =========================================================
    // VERIFY OTP
    // =========================================================

    const handleVerifyOtp = async (e) => {
        e.preventDefault();

        if (!otp || otp.length < 4) {
            setMessage("Please enter a valid OTP.");
            setMessageType("error");
            return;
        }

        setMessage("");
        setLoading(true);

        try {
            let result;

            // =====================================================
            // SIGNUP OTP
            // =====================================================

            if (otpType === "signup") {
                result = await api.post(
                    `${Config.new.site_api}/survey/verifyOtpForAuditorReg`,
                    {
                        name: signupData.name.trim(),
                        email: signupData.email.trim().toLowerCase(),
                        otp: otp,
                        organizationName:signupData.organizationName
                    }
                );

                console.log("Signup OTP verification:", result);

                if (
                    result?.error === false &&
                    result?.code === 200
                ) {
                    setMessage(
                        result?.message ||
                        "User registered successfully."
                    );

                    setMessageType("success");

                    setShowOtp(false);
                    setOtp("");

                    setActiveTab("login");

                    setLoginIdentifier(signupData.email);
                } else {
                    setMessage(
                        result?.message ||
                        "OTP verification failed."
                    );

                    setMessageType("error");
                }
            }

            // =====================================================
            // LOGIN OTP
            // =====================================================

            if (otpType === "login") {
                result = await api.post(
                    `${Config.new.site_api}/survey/verifyOtpForAuditorLogin`,
                    {
                        email: loginIdentifier.trim().toLowerCase(),
                        otp: otp,
                    }
                );

                console.log("Login OTP verification:", result);

                if (
                    result?.error === false &&
                    result?.code === 200
                ) {
                    const auditorData = result?.data;

                    console.log(
                        "Logged in auditor:",
                        auditorData
                    );

                    // =================================================
                    // STORE AUDITOR DATA
                    // =================================================

                    localStorage.setItem(
                        "surveyAuditor",
                        JSON.stringify(auditorData)
                    );

                    // =================================================
                    // GET AUDITOR NAME
                    //
                    // Change these according to your actual API
                    // response if required.
                    // =================================================

                    const loggedInName =
                        auditorData?.name ||
                        auditorData?.auditor_name ||
                        auditorData?.first_name ||
                        signupData.name ||
                        "Auditor";

                    setAuditorName(loggedInName);

                    // =================================================
                    // SHOW DASHBOARD ON SAME PAGE
                    // =================================================

                    setShowOtp(false);
                    setOtp("");

                    setShowDashboard(true);
                    await fetchSurveys("ongoing");
                    setMessage("");
                    setMessageType("");
                } else {
                    setMessage(
                        result?.message ||
                        "OTP verification failed."
                    );

                    setMessageType("error");
                }
            }
        } catch (error) {
            console.error(
                "OTP verification error:",
                error
            );

            setMessage(
                error?.response?.message ||
                "Something went wrong while verifying OTP."
            );

            setMessageType("error");
        } finally {
            setLoading(false);
        }
    };

    // =========================================================
    // BACK FROM OTP
    // =========================================================

    const handleBackFromOtp = () => {
        setShowOtp(false);
        setOtp("");
        setMessage("");
        setMessageType("");
    };
    const fetchSurveys = async (status = "ongoing") => {
        try {
            setLoading(true);

            const auditorData = JSON.parse(
                localStorage.getItem("surveyAuditor")
            );

            const auditorId =
                auditorData?.auditorId ||
                auditorData?.id ||
                auditorData?._id;

            const categoryId =
                params?.match?.params?.id ||
                params?.params?.id;

            if (!auditorId) {
                console.error("Auditor ID not found");
                return;
            }

            if (!categoryId) {
                console.error("Category ID not found");
                return;
            }

            console.log("Fetching surveys:", {
                categoryId,
                auditorId,
                filterStatus: status
            });

            let payload = {
                categoryId: categoryId,
                auditorId: auditorId,
                filterStatus: status
            }
            if (JSON.parse(localStorage.getItem("surveyAuditor"))?.role && JSON.parse(localStorage.getItem("surveyAuditor"))?.role == 'admin') {
                payload.role = "admin"
            }
             if(JSON.parse(localStorage.getItem("surveyAuditor"))?.organizationName){
                payload['organizationName']=JSON.parse(localStorage.getItem("surveyAuditor"))?.organizationName
            }

            const result = await api.post(
                `${Config.new.site_api}/survey/categoryWiseAuditorSurvey`,
                payload
            );
            console.log("Survey API response:", result);

            if (
                result?.error === false &&
                result?.code === 200
            ) {
                // IMPORTANT:
                // Your API response is result.data
                const surveys = result?.data || [];

                console.log("Survey list:", surveys);

                // setSurveyData((prev) => ({
                //     ...prev,
                //     [status]: surveys
                // }));
                setSurveyData(surveys)
            } else {
                setMessage(
                    result?.message ||
                    "Unable to fetch surveys."
                );

                setMessageType("error");
            }

        } catch (error) {

            console.error(
                "Fetch survey error:",
                error
            );

            setMessage(
                error?.response?.message ||
                "Something went wrong while fetching surveys."
            );

            setMessageType("error");

        } finally {
            setLoading(false);
        }
    };

    // =========================================================
    // DASHBOARD TAB DATA
    // =========================================================

    const getCurrentSurveys = async () => {

        if (activeDashboardTab === "ongoing") {
            return surveyData.ongoing;
        }

        if (activeDashboardTab === "saved") {
            return surveyData.saved;
        }

        if (activeDashboardTab === "submitted") {
            return surveyData.submitted;
        }

        return [];
    };

    const handleLogout = () => {
    // Clear auditor session data
    localStorage.removeItem("auditorData");
    localStorage.removeItem("userData");
    localStorage.removeItem("surveyAuditor")

    sessionStorage.clear();

    // Refresh the current page
    window.location.reload();
};


    // =========================================================
    // VIEW SURVEY
    // =========================================================

    const startNewSurvey = async (survey) => {
        console.log("Selected Survey:", survey);

        // history.push(`/NewSurvey/${survey._id || survey.surveyId}`);

        activeDashboardTab == "ongoing" ? history.push(`/NewSurvey/${survey._id || survey.surveyId}`)
            : activeDashboardTab == "saved" ? history.push(`/savedSurvey/${survey._id || survey.surveyId}/rId=${survey.responseId}`)
                : activeDashboardTab == "submitted" && history.push(`/savedSurvey/${survey._id || survey.surveyId}/rId=${survey.responseId}`) //: null
    };

    // =========================================================
    // LOGIN PAGE
    // =========================================================

    const renderLoginPage = () => {
        return (
            <>
                <div className="survey-auth-screen">
                    <div className="survey-auth-wrap">

                        <div className="survey-auth-topbar"></div>

                        <div className="survey-auth-center">
                            <div className="survey-auth-card">

                                {/* =================================================
                                    OTP SCREEN
                                ================================================== */}

                                {showOtp ? (
                                    <div>

                                        <div className="survey-otp-icon">
                                            <i className="bi bi-shield-lock"></i>
                                        </div>

                                        <h2 className="survey-auth-title text-center">
                                            Verify your email
                                        </h2>

                                        <p className="survey-auth-caption text-center">
                                            Enter the OTP sent to
                                            <br />

                                            <strong>
                                                {otpType === "signup"
                                                    ? signupData.email
                                                    : loginIdentifier}
                                            </strong>
                                        </p>

                                        <form
                                            onSubmit={
                                                handleVerifyOtp
                                            }
                                        >

                                            <div className="survey-form-group last">

                                                <label className="survey-form-label">
                                                    Enter OTP
                                                </label>

                                                <input
                                                    type="text"
                                                    inputMode="numeric"
                                                    maxLength={6}
                                                    className="survey-form-control survey-otp-input"
                                                    placeholder="Enter 6 digit OTP"
                                                    value={otp}
                                                    onChange={
                                                        handleOtpChange
                                                    }
                                                    autoFocus
                                                    required
                                                />

                                            </div>

                                            <button
                                                type="submit"
                                                className="survey-btn-brand"
                                                disabled={loading}
                                            >
                                                {loading ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm"></span>
                                                        Verifying...
                                                    </>
                                                ) : (
                                                    <>
                                                        Verify OTP
                                                        <i className="bi bi-check-circle"></i>
                                                    </>
                                                )}
                                            </button>

                                        </form>

                                        <button
                                            type="button"
                                            className="survey-back-btn"
                                            onClick={
                                                handleBackFromOtp
                                            }
                                        >
                                            <i className="bi bi-arrow-left"></i>
                                            &nbsp; Back
                                        </button>

                                    </div>
                                ) : (
                                    <>
                                        {/* =================================================
                                            TABS
                                        ================================================== */}

                                        <div className="survey-seg-tabs">

                                            <button
                                                type="button"
                                                className={
                                                    activeTab ===
                                                        "signup"
                                                        ? "active"
                                                        : ""
                                                }
                                                onClick={() => {
                                                    setActiveTab(
                                                        "signup"
                                                    );

                                                    setMessage("");
                                                }}
                                            >
                                                Sign up
                                            </button>

                                            <button
                                                type="button"
                                                className={
                                                    activeTab ===
                                                        "login"
                                                        ? "active"
                                                        : ""
                                                }
                                                onClick={() => {
                                                    setActiveTab(
                                                        "login"
                                                    );

                                                    setMessage("");
                                                }}
                                            >
                                                Log in
                                            </button>

                                        </div>

                                        {/* MESSAGE */}

                                        {message && (
                                            <div
                                                className={`survey-message ${messageType ===
                                                    "success"
                                                    ? "success"
                                                    : "error"
                                                    }`}
                                            >
                                                <i
                                                    className={
                                                        messageType ===
                                                            "success"
                                                            ? "bi bi-check-circle"
                                                            : "bi bi-exclamation-circle"
                                                    }
                                                ></i>

                                                <span>
                                                    {message}
                                                </span>
                                            </div>
                                        )}

                                        {/* =================================================
                                            SIGNUP
                                        ================================================== */}

                                        {activeTab === "signup" && (
                                            <div>

                                                <h2 className="survey-auth-title">
                                                    Create your account
                                                </h2>

                                                <p className="survey-auth-caption">
                                                    Verify once, then
                                                    access every survey
                                                    assigned to you.
                                                </p>

                                                <form
                                                    onSubmit={
                                                        handleSignupSubmit
                                                    }
                                                >

                                                    <div className="survey-form-group">

                                                        <label className="survey-form-label">
                                                            Auditor name
                                                        </label>

                                                        <div className="survey-input-icon-group">

                                                            <i className="bi bi-person"></i>

                                                            <input
                                                                type="text"
                                                                name="name"
                                                                className="survey-form-control"
                                                                placeholder="e.g. Aditi Sharma"
                                                                value={
                                                                    signupData.name
                                                                }
                                                                onChange={
                                                                    handleSignupChange
                                                                }
                                                                required
                                                            />

                                                        </div>

                                                    </div>

                                                    <div className="survey-form-group ">

                                                        <label className="survey-form-label">
                                                            Email ID
                                                        </label>

                                                        <div className="survey-input-icon-group">

                                                            <i className="bi bi-envelope"></i>

                                                            <input
                                                                type="email"
                                                                name="email"
                                                                className="survey-form-control"
                                                                placeholder="you@example.com"
                                                                value={
                                                                    signupData.email
                                                                }
                                                                onChange={
                                                                    handleSignupChange
                                                                }
                                                                required
                                                            />

                                                        </div>

                                                        <div className="survey-form-group last">

                                                        <label className="survey-form-label">
                                                            Organization Name
                                                        </label>

                                                        <div className="survey-input-icon-group">

                                                            <i className="bi bi-building"></i>

                                                            <input
                                                                type="text"
                                                                name="organizationName"
                                                                className="survey-form-control"
                                                                placeholder="Qdegrees"
                                                                value={
                                                                    signupData.organizationName
                                                                }
                                                                onChange={
                                                                    handleSignupChange
                                                                }
                                                                required
                                                            />

                                                        </div>
                                                        </div>

                                                    </div>

                                                    <button
                                                        type="submit"
                                                        className="survey-btn-brand"
                                                        disabled={
                                                            loading
                                                        }
                                                    >
                                                        {loading ? (
                                                            <>
                                                                <span className="spinner-border spinner-border-sm"></span>
                                                                Sending OTP...
                                                            </>
                                                        ) : (
                                                            <>
                                                                Send verification
                                                                OTP
                                                                <i className="bi bi-arrow-right"></i>
                                                            </>
                                                        )}
                                                    </button>

                                                    <p className="survey-helper-text">
                                                        We'll email a
                                                        one-time code to
                                                        confirm it's
                                                        really you.
                                                    </p>

                                                </form>

                                            </div>
                                        )}

                                        {/* =================================================
                                            LOGIN
                                        ================================================== */}

                                        {activeTab === "login" && (
                                            <div>

                                                <h2 className="survey-auth-title">
                                                    Welcome back
                                                </h2>

                                                <p className="survey-auth-caption">
                                                    Log in with a one-time
                                                    code — no password
                                                    needed.
                                                </p>

                                                <form
                                                    onSubmit={
                                                        handleLoginSubmit
                                                    }
                                                >

                                                    <div className="survey-form-group last">

                                                        <label className="survey-form-label">
                                                            Email
                                                        </label>

                                                        <div className="survey-input-icon-group">

                                                            <i className="bi bi-envelope"></i>

                                                            <input
                                                                type="email"
                                                                className="survey-form-control"
                                                                placeholder="you@example.com"
                                                                value={
                                                                    loginIdentifier
                                                                }
                                                                onChange={(
                                                                    e
                                                                ) =>
                                                                    setLoginIdentifier(
                                                                        e
                                                                            .target
                                                                            .value
                                                                    )
                                                                }
                                                                required
                                                            />

                                                        </div>

                                                    </div>

                                                    <button
                                                        type="submit"
                                                        className="survey-btn-brand"
                                                        disabled={
                                                            loading
                                                        }
                                                    >
                                                        {loading ? (
                                                            <>
                                                                <span className="spinner-border spinner-border-sm"></span>
                                                                Sending OTP...
                                                            </>
                                                        ) : (
                                                            <>
                                                                Send OTP
                                                                <i className="bi bi-arrow-right"></i>
                                                            </>
                                                        )}
                                                    </button>

                                                </form>

                                                <div className="survey-divider">
                                                    new here
                                                </div>

                                                <button
                                                    type="button"
                                                    className="survey-btn-sky"
                                                    onClick={() => {
                                                        setActiveTab(
                                                            "signup"
                                                        );

                                                        setMessage("");
                                                    }}
                                                >
                                                    <i className="bi bi-person-plus"></i>
                                                    &nbsp; Create a Auditor
                                                    account
                                                </button>

                                            </div>
                                        )}

                                    </>
                                )}

                            </div>
                        </div>

                    </div>
                </div>
            </>
        );
    };

    // =========================================================
    // DASHBOARD PAGE
    // =========================================================

    const renderDashboard = () => {
        const currentSurveys = getCurrentSurveys();

        return (
            <div className="survey-dashboard">
                {loading && <Loader />}
                {/* =====================================================
                    HEADER
                ====================================================== */}

                <section
                    id="all-section"
                    className="admin-header position-relative"
                >
                    <nav
                        className="navbar navbar-expand-lg bg-white p-0 border border-bottom"
                        style={{ height: "80px" }}
                    >
                        <div className="container-fluid">

                            <a
                                className="navbar-brand1 logo-itemsw logoMain"
                                href="#"
                            >
                                <img
                                    src="../images/new-logo.png"
                                    alt=""
                                    style={{
                                        height: "70px",
                                        margin: "5px",
                                    }}
                                />
                            </a>

                            <div className="survey-header-right d-flex align-items-center">

                                <div className="survey-header-user">

                                    <div className="survey-header-user-icon">
                                        <i className="bi bi-person"></i>
                                    </div>

                                    <div>
                                        <div className="survey-header-user-label">
                                            Auditor
                                        </div>

                                        <div className="survey-header-user-name">
                                            {auditorName}
                                        </div>
                                    </div>

                                </div>

                                {/* Logout Button */}
                                <button
                                    type="button"
                                    className="btn btn-outline-danger ms-4"
                                    onClick={handleLogout}
                                >
                                    <i className="bi bi-box-arrow-right me-2"></i>
                                    Logout
                                </button>

                            </div>

                        </div>
                    </nav>
                </section>

                {/* =====================================================
                    DASHBOARD CONTENT
                ====================================================== */}

                <div className="survey-dashboard-container">

                    <div className="survey-dashboard-intro">

                        <div className="survey-dashboard-small-title">
                            Good to see you
                        </div>

                        <h1>
                            Hi, {auditorName} — here are your surveys
                        </h1>

                    </div>

                    {/* =================================================
                        TABS
                    ================================================== */}

                    <div className="survey-dashboard-tabs">

                        <button
                            type="button"
                            className={
                                activeDashboardTab === "ongoing"
                                    ? "active"
                                    : ""
                            }
                            onClick={async () => {
                                setActiveDashboardTab(
                                    "ongoing"
                                )
                                fetchSurveys("ongoing");
                            }
                            }
                        >
                            <i className="bi bi-hourglass-split"></i>

                            <span>Active</span>

                            <span className="survey-count">
                                {surveyData.ongoing.length}
                            </span>
                        </button>

                        <button
                            type="button"
                            className={
                                activeDashboardTab === "saved"
                                    ? "active"
                                    : ""
                            }
                            onClick={() =>
                                setActiveDashboardTab(
                                    "saved"
                                )
                            }
                        >
                            <i className="bi bi-bookmark"></i>

                            <span>Saved</span>

                            <span className="survey-count light">
                                {surveyData.saved.length}
                            </span>
                        </button>

                        <button
                            type="button"
                            className={
                                activeDashboardTab === "submitted"
                                    ? "active"
                                    : ""
                            }
                            onClick={() =>
                                setActiveDashboardTab(
                                    "submitted"
                                )
                            }
                        >
                            <i className="bi bi-check-circle"></i>

                            <span>Submitted</span>

                            <span className="survey-count light">
                                {surveyData.submitted.length}
                            </span>
                        </button>

                        {(activeDashboardTab === "saved" || activeDashboardTab === "submitted") && (<div className="survey-search">
                            <i className="bi bi-search"></i> <input type="text" placeholder="Search Response ID..." value={surveySearch} onChange={(e) => setSurveySearch(e.target.value)} />
                            {surveySearch && (<button type="button" className="clear-search" onClick={() => setSurveySearch("")} > <i className="bi bi-x"></i> </button>)} </div>)}

                    </div>

                    {/* =================================================
                        SURVEY LIST
                    ================================================== */}
                    {console.log(filteredSurveys, "filteredSurveys")}
                    <div className="survey-list">

                        {filteredSurveys.length > 0 ? (
                            filteredSurveys.map((survey) => (
                                <div
                                    className="survey-list-card"
                                    key={survey.id}
                                >

                                    {/* Left icon */}

                                    <div className="survey-list-icon">
                                        <i className="bi bi-clipboard2-pulse"></i>
                                    </div>

                                    {/* Survey information */}

                                    <div className="survey-list-info">

                                        <div className="survey-list-title">
                                            {survey.survey_name}
                                        </div>

                                        <div className="survey-list-company">
                                            {survey?.responseId && `Res. ID -  ${survey.responseId}`}
                                        </div>
                                        <div className="survey-list-company">
                                            {survey?.filterAnswer &&  survey?.filterAnswer}
                                        </div>

                                    </div>

                                    {/* End date */}

                                    {survey?.endDate && <div className="survey-list-date">

                                        <span>
                                            Ends
                                        </span>

                                        <strong>
                                            {survey.endDate}
                                        </strong>

                                    </div>}

                                    {/* View */}

                                    {/* <button
                                        type="button"
                                        className="survey-view-btn"
                                        onClick={() =>
                                            // activeDashboardTab=="ongoing"?
                                            startNewSurvey(
                                                survey
                                            )//:activeDashboardTab=="saved"?"saved":activeDashboardTab=="submitted"?"submitted":null
                                        }
                                    >
                                        <i className="bi bi-eye"></i>
                                    </button> */}
                                    <div className="survey-list-actions">

                                        {/* Start Again */}
                                        {activeDashboardTab !== 'submitted' && <button
                                            type="button"
                                            className="survey-action-btn survey-start-btn"
                                            onClick={() => startNewSurvey(survey)}
                                            title="Start Again"
                                        >
                                            <i className="bi bi-arrow-clockwise"></i>
                                            <span>{activeDashboardTab == "ongoing" ? "Start Survey" : "Start Again"}</span>
                                        </button>}

                                        {/* Edit */}
                                        {activeDashboardTab !== "ongoing" && <button
                                            type="button"
                                            className="survey-action-btn survey-edit-btn"
                                            onClick={() => history.push(`/editSurvey/${survey._id || survey.surveyId}/rId=${survey.responseId}`)}
                                            title="Edit Survey"
                                        >
                                            <i className="bi bi-pencil-square"></i>
                                            <span>Edit</span>
                                        </button>}

                                    </div>

                                </div>
                            ))
                        ) : (
                            <div className="survey-empty-state">

                                <i className="bi bi-clipboard-x"></i>

                                <h3>
                                    No surveys found
                                </h3>

                                <p>
                                    There are no surveys in this
                                    section.
                                </p>

                            </div>
                        )}

                    </div>

                </div>

            </div>
        );
    };

    // =========================================================
    // MAIN RETURN
    // =========================================================

    return (
        <>
            {showDashboard
                ? renderDashboard()
                : (
                    <>
                        {/* HEADER ON LOGIN/SIGNUP PAGE */}

                        <section
                            id="all-section"
                            className="admin-header position-relative"
                        >
                            <nav
                                className="navbar navbar-expand-lg bg-white p-0 border border-bottom"
                                style={{ height: "80px" }}
                            >
                                <div className="container-fluid">

                                    <a
                                        className="navbar-brand1 logo-itemsw logoMain"
                                        href="#"
                                    >
                                        <img
                                            src="../images/new-logo.png"
                                            alt=""
                                            style={{
                                                height: "70px",
                                                margin: "5px",
                                            }}
                                        />
                                    </a>

                                    <ul className="navbar-nav flex-row align-items-center justify-contents-center w-auto"></ul>

                                </div>
                            </nav>
                        </section>

                        {renderLoginPage()}
                    </>
                )}

            <style>{`

/* =====================================================
   COMMON
====================================================== */

:root {
    --orange: #FF7A33;
    --orange-dark: #E8611C;
    --orange-light: #FFF0E6;

    --sky: #0EA5E9;
    --sky-dark: #0284C7;
    --sky-light: #E4F6FF;

    --bg: #F7F9FB;
    --surface: #FFFFFF;

    --ink: #1F2733;
    --ink-muted: #7C8794;

    --border: #E9EEF2;

    --radius-lg: 20px;
    --radius-sm: 10px;

    --shadow-soft:
        0 10px 30px -12px
        rgba(31, 39, 51, 0.12);
}


/* =====================================================
   LOGIN
====================================================== */

.survey-auth-screen {
    min-height: calc(100vh - 80px);
    background: var(--bg);

    background-image:
        radial-gradient(
            60% 50% at 100% 0%,
            rgba(14,165,233,0.08) 0%,
            rgba(14,165,233,0) 60%
        ),
        radial-gradient(
            50% 40% at 0% 100%,
            rgba(255,122,51,0.08) 0%,
            rgba(255,122,51,0) 60%
        );

    background-attachment: fixed;

    font-family: "Inter", sans-serif;

    color: var(--ink);
}

.survey-auth-screen *,
.survey-auth-screen *::before,
.survey-auth-screen *::after {
    box-sizing: border-box;
}

.survey-auth-wrap {
    min-height: calc(100vh - 80px);

    display: flex;

    flex-direction: column;
}

.survey-auth-topbar {
    padding: 20px clamp(20px, 5vw, 64px) 0;
}

.survey-auth-center {
    flex: 1;

    display: flex;

    align-items: center;

    justify-content: center;

    padding: 24px;
}

.survey-auth-card {
    width: 100%;

    max-width: 440px;

    padding: clamp(28px, 4vw, 44px);

    background: var(--surface);

    border: 1px solid var(--border);

    border-radius: var(--radius-lg);

    box-shadow: var(--shadow-soft);
}

.survey-seg-tabs {
    display: flex;

    background: var(--bg);

    border: 1px solid var(--border);

    border-radius: 999px;

    padding: 4px;

    margin-bottom: 28px;
}

.survey-seg-tabs button {
    flex: 1;

    border: 0;

    background: transparent;

    padding: 9px 0;

    border-radius: 999px;

    font-weight: 600;

    font-size: 0.92rem;

    color: var(--ink-muted);

    transition: 0.2s;

    cursor: pointer;
}

.survey-seg-tabs button.active {
    background: var(--surface);

    color: var(--ink);

    box-shadow:
        0 4px 12px
        rgba(31,39,51,0.08);
}

.survey-auth-title {
    font-size: 1.5rem;

    font-weight: 800;

    margin: 0 0 6px;
}

.survey-auth-caption {
    color: var(--ink-muted);

    font-size: 0.95rem;

    margin-bottom: 24px;
}

.survey-form-group {
    margin-bottom: 16px;
}

.survey-form-group.last {
    margin-bottom: 24px;
}

.survey-form-label {
    display: block;

    font-weight: 600;

    font-size: 0.85rem;

    color: var(--ink);

    margin-bottom: 6px;
}

.survey-input-icon-group {
    position: relative;
}

.survey-input-icon-group i {
    position: absolute;

    left: 14px;

    top: 50%;

    transform: translateY(-50%);

    color: var(--ink-muted);

    font-size: 1rem;

    pointer-events: none;
}

.survey-form-control {
    width: 100%;

    border-radius: var(--radius-sm);

    border: 1.5px solid var(--border);

    padding: 0.65rem 0.9rem 0.65rem 40px;

    font-size: 0.95rem;

    background: #FCFDFE;

    color: var(--ink);

    outline: none;
}

.survey-form-control:focus {
    border-color: var(--sky);

    box-shadow:
        0 0 0 4px
        var(--sky-light);

    background: #fff;
}

.survey-btn-brand {
    width: 100%;

    border: 0;

    background:
        linear-gradient(
            135deg,
            var(--orange),
            var(--orange-dark)
        );

    color: #fff;

    font-weight: 700;

    border-radius: var(--radius-sm);

    padding: 0.7rem 1rem;

    box-shadow:
        0 8px 18px -6px
        rgba(255,122,51,0.55);

    transition:
        transform 0.15s ease,
        box-shadow 0.15s ease;

    cursor: pointer;

    display: flex;

    align-items: center;

    justify-content: center;

    gap: 8px;
}

.survey-btn-brand:hover {
    transform: translateY(-1px);

    box-shadow:
        0 10px 22px -6px
        rgba(255,122,51,0.65);
}

.survey-btn-brand:disabled {
    opacity: 0.55;

    transform: none;

    box-shadow: none;

    cursor: not-allowed;
}

.survey-btn-sky {
    width: 100%;

    background: var(--sky-light);

    border: 1.5px solid transparent;

    color: var(--sky-dark);

    font-weight: 700;

    border-radius: var(--radius-sm);

    padding: 0.55rem 1rem;

    cursor: pointer;
}

.survey-btn-sky:hover {
    background: #d5f0ff;

    color: var(--sky-dark);
}

.survey-divider {
    display: flex;

    align-items: center;

    gap: 10px;

    color: var(--ink-muted);

    font-size: 0.78rem;

    margin: 18px 0;
}

.survey-divider::before,
.survey-divider::after {
    content: "";

    flex: 1;

    height: 1px;

    background: var(--border);
}

.survey-helper-text {
    text-align: center;

    margin-top: 12px;

    margin-bottom: 0;

    font-size: 0.82rem;

    color: var(--ink-muted);

    line-height: 1.5;
}

.survey-otp-icon {
    width: 56px;

    height: 56px;

    border-radius: 16px;

    background: var(--orange-light);

    color: var(--orange-dark);

    display: flex;

    align-items: center;

    justify-content: center;

    margin: 0 auto 20px;

    font-size: 1.5rem;
}

.survey-otp-input {
    padding-left: 12px;

    text-align: center;

    font-size: 1.4rem;

    font-weight: 700;

    letter-spacing: 8px;
}

.survey-back-btn {
    display: block;

    margin: 18px auto 0;

    border: 0;

    background: transparent;

    color: var(--sky-dark);

    font-weight: 600;

    cursor: pointer;
}

.survey-message {
    display: flex;

    align-items: center;

    gap: 8px;

    border-radius: 10px;

    padding: 10px 12px;

    margin-bottom: 18px;

    font-size: 0.85rem;

    font-weight: 600;
}

.survey-message.success {
    background: #E9FBF0;

    color: #15803D;

    border: 1px solid #BBF7D0;
}

.survey-message.error {
    background: #FEF2F2;

    color: #DC2626;

    border: 1px solid #FECACA;
}

.survey-btn-brand .spinner-border {
    width: 16px;

    height: 16px;

    border-width: 2px;
}


/* =====================================================
   DASHBOARD
====================================================== */

.survey-dashboard {
    min-height: 100vh;

    background: #F7F9FB;

    color: #1F2733;

    font-family: "Inter", sans-serif;
}


/* =====================================================
   HEADER
====================================================== */

.survey-dashboard .navbar {
    background: #fff !important;
}

.survey-header-right {
    display: flex;

    align-items: center;

    margin-right: 25px;
}

.survey-header-user {
    display: flex;

    align-items: center;

    gap: 10px;
}

.survey-header-user-icon {
    width: 42px;

    height: 42px;

    border-radius: 50%;

    background: #E4F6FF;

    color: #0284C7;

    display: flex;

    align-items: center;

    justify-content: center;

    font-size: 18px;
}

.survey-header-user-label {
    color: #7C8794;

    font-size: 11px;

    line-height: 1.2;
}

.survey-header-user-name {
    color: #1F2733;

    font-size: 14px;

    font-weight: 700;

    margin-top: 2px;
}


/* =====================================================
   DASHBOARD CONTAINER
====================================================== */

.survey-dashboard-container {
    max-width: 1004px;

    margin: 0 auto;

    padding: 22px 0 60px;
}

.survey-dashboard-intro {
    margin-bottom: 22px;
}

.survey-dashboard-small-title {
    color: #718096;

    font-size: 14px;

    margin-bottom: 2px;
}

.survey-dashboard-intro h1 {
    margin: 0;

    font-size: 27px;

    line-height: 1.3;

    font-weight: 500;

    color: #10243E;

    letter-spacing: -0.5px;
}


/* =====================================================
   DASHBOARD TABS
====================================================== */

.survey-dashboard-tabs {
    display: flex;

    align-items: center;

    gap: 8px;

    margin-bottom: 18px;
}

.survey-dashboard-tabs button {
    height: 38px;

    padding: 0 16px;

    border: 1px solid #E1E7ED;

    background: #FFFFFF;

    color: #748399;

    border-radius: 22px;

    display: flex;

    align-items: center;

    gap: 8px;

    font-size: 14px;

    font-weight: 600;

    cursor: pointer;

    transition: all 0.2s ease;
}

.survey-dashboard-tabs button i {
    font-size: 14px;
}

.survey-dashboard-tabs button.active {
    background: #202A38;

    border-color: #202A38;

    color: #FFFFFF;
}

.survey-count {
    min-width: 23px;

    height: 23px;

    border-radius: 50%;

    background: rgba(255,255,255,0.18);

    display: flex;

    align-items: center;

    justify-content: center;

    font-size: 12px;

    font-weight: 700;
}

.survey-count.light {
    background: #F0F3F6;

    color: #748399;
}

.survey-dashboard-tabs button.active .survey-count {
    background: rgba(255,255,255,0.18);

    color: #fff;
}


/* =====================================================
   SURVEY LIST
====================================================== */

.survey-list {
    display: flex;

    flex-direction: column;

    gap: 12px;
}

.survey-list-card {
    min-height: 80px;

    background: #FFFFFF;

    border: 1px solid #E4E9EE;

    border-radius: 15px;

    display: flex;

    align-items: center;

    padding: 16px 18px;

    transition:
        box-shadow 0.2s ease,
        transform 0.2s ease;
}

.survey-list-card:hover {
    box-shadow:
        0 5px 18px
        rgba(31,39,51,0.06);
}


/* =====================================================
   SURVEY ICON
====================================================== */

.survey-list-icon {
    width: 46px;

    height: 46px;

    flex-shrink: 0;

    border-radius: 12px;

    background: #E4F6FF;

    color: #0284C7;

    display: flex;

    align-items: center;

    justify-content: center;

    font-size: 18px;

    margin-right: 16px;
}


/* =====================================================
   SURVEY INFORMATION
====================================================== */

.survey-list-info {
    flex: 1;

    min-width: 0;
}

.survey-list-title {
    font-size: 16px;

    line-height: 1.3;

    font-weight: 700;

    color: #101B2C;

    margin-bottom: 4px;

    overflow: hidden;

    text-overflow: ellipsis;

    white-space: nowrap;
}

.survey-list-company {
    font-size: 14px;

    color: #718096;

    overflow: hidden;

    text-overflow: ellipsis;

    white-space: nowrap;
}


/* =====================================================
   DATE
====================================================== */

.survey-list-date {
    display: flex;

    align-items: center;

    gap: 4px;

    margin-right: 16px;

    white-space: nowrap;

    font-size: 13px;
}

.survey-list-date span {
    color: #718096;
}

.survey-list-date strong {
    color: #18324D;

    font-weight: 600;
}


/* =====================================================
   ACTIONS
====================================================== */

.survey-list-actions {
    display: flex;

    align-items: center;

    gap: 8px;

    flex-shrink: 0;
}

.survey-action-btn {
    height: 40px;

    border-radius: 10px;

    display: flex;

    align-items: center;

    justify-content: center;

    gap: 7px;

    padding: 0 13px;

    font-size: 13px;

    font-weight: 600;

    cursor: pointer;

    white-space: nowrap;

    transition:
        background 0.2s ease,
        border-color 0.2s ease,
        transform 0.2s ease,
        box-shadow 0.2s ease;
}

.survey-action-btn i {
    font-size: 15px;
}


/* =====================================================
   START AGAIN BUTTON
====================================================== */

.survey-start-btn {
    border: 1px solid #BAE6FD;

    background: #E4F6FF;

    color: #0284C7;
}

.survey-start-btn:hover {
    background: #D5F0FF;

    border-color: #7DD3FC;

    transform: translateY(-1px);

    box-shadow:
        0 4px 10px
        rgba(14,165,233,0.12);
}


/* =====================================================
   EDIT BUTTON
====================================================== */

.survey-edit-btn {
    border: 1px solid #FED7AA;

    background: #FFF7ED;

    color: #EA580C;
}

.survey-edit-btn:hover {
    background: #FFEDD5;

    border-color: #FDBA74;

    transform: translateY(-1px);

    box-shadow:
        0 4px 10px
        rgba(234,88,12,0.10);
}

.survey-action-btn:active {
    transform: translateY(0);
}


/* =====================================================
   EMPTY STATE
====================================================== */

.survey-empty-state {
    background: #fff;

    border: 1px solid #E4E9EE;

    border-radius: 15px;

    padding: 50px 20px;

    text-align: center;

    color: #718096;
}

.survey-empty-state i {
    font-size: 40px;

    color: #B5C0CC;

    display: block;

    margin-bottom: 10px;
}

.survey-empty-state h3 {
    margin: 0 0 5px;

    color: #263548;

    font-size: 17px;
}

.survey-empty-state p {
    margin: 0;

    font-size: 14px;
}


/* =====================================================
   MOBILE - TABLET
====================================================== */

@media (max-width: 768px) {

    .survey-dashboard-container {
        padding: 20px 16px 50px;
    }

    .survey-dashboard-intro h1 {
        font-size: 22px;
    }

    .survey-header-right {
        margin-right: 10px;
    }

    .survey-header-user-name {
        max-width: 120px;

        overflow: hidden;

        text-overflow: ellipsis;

        white-space: nowrap;
    }

    .survey-list-card {
        padding: 14px;

        flex-wrap: wrap;
    }

    .survey-list-info {
        width: calc(100% - 62px);

        flex: none;
    }

    .survey-list-date {
        margin-left: 62px;

        margin-top: 10px;

        margin-right: auto;
    }

    .survey-list-actions {
        width: calc(100% - 62px);

        margin-left: 62px;

        margin-top: 10px;
    }

    .survey-action-btn {
        flex: 1;

        min-width: 0;
    }

    .survey-dashboard-tabs {
        overflow-x: auto;

        padding-bottom: 3px;

        scrollbar-width: none;
    }

    .survey-dashboard-tabs::-webkit-scrollbar {
        display: none;
    }

    .survey-dashboard-tabs button {
        flex-shrink: 0;
    }
}


/* =====================================================
   MOBILE - SMALL
====================================================== */

@media (max-width: 576px) {

    .survey-auth-center {
        padding: 16px;

        align-items: flex-start;

        padding-top: 30px;
    }

    .survey-auth-card {
        padding: 24px 20px;
    }

    .survey-otp-input {
        letter-spacing: 5px;
    }

    .survey-dashboard-intro h1 {
        font-size: 21px;
    }

    .survey-header-user-icon {
        width: 36px;

        height: 36px;
    }

    .survey-header-user-label {
        display: none;
    }

    .survey-list-title {
        font-size: 15px;
    }

    .survey-list-company {
        font-size: 13px;
    }

    .survey-list-card {
        padding: 13px;
    }

    .survey-list-icon {
        width: 42px;

        height: 42px;

        margin-right: 12px;
    }

    .survey-list-info {
        width: calc(100% - 54px);
    }

    .survey-list-date {
        margin-left: 54px;
    }

    .survey-list-actions {
        width: calc(100% - 54px);

        margin-left: 54px;

        gap: 6px;
    }

    .survey-action-btn {
        height: 38px;

        padding: 0 8px;

        font-size: 12px;

        gap: 5px;
    }

    .survey-action-btn i {
        font-size: 14px;
    }
}


/* =====================================================
   VERY SMALL MOBILE
====================================================== */

@media (max-width: 380px) {

    .survey-action-btn span {
        display: none;
    }

    .survey-action-btn {
        width: 42px;

        flex: 0 0 42px;

        padding: 0;
    }

    .survey-list-actions {
        justify-content: flex-end;
    }
}

.survey-dashboard-tabs { display: flex; align-items: center; gap: 10px; } 
.survey-search { position: relative; display: flex; align-items: center; margin-left: auto; } 
.survey-search > i { position: absolute; left: 12px; font-size: 16px; color: #777; z-index: 1; } 
.survey-search input { width: 240px; height: 40px; padding: 0 35px; border: 1px solid #ddd; border-radius: 6px; outline: none; font-size: 14px; }
 .survey-search input:focus { border-color: #999; } .clear-search { position: absolute; right: 8px; border: none; background: transparent; cursor: pointer; padding: 3px; color: #777; }
  .clear-search:hover { color: #000; }

`}</style>

        </>
    );
};

export default LoginSignupForSurveyAttempt;

// import React, { useEffect, useState } from "react";
// import API from "../utils/apiCalling";
// import Config from "../config/env";

// const LoginSignupForSurveyAttempt = () => {

//     let api = new API();

//     // =========================================================
//     // LOGIN / SIGNUP
//     // =========================================================

//     const [activeTab, setActiveTab] = useState("signup");

//     const [signupData, setSignupData] = useState({
//         name: "",
//         email: "",
//     });

//     const [loginIdentifier, setLoginIdentifier] = useState("");

//     // =========================================================
//     // OTP
//     // =========================================================

//     const [showOtp, setShowOtp] = useState(false);
//     const [otp, setOtp] = useState("");
//     const [otpType, setOtpType] = useState("");

//     // =========================================================
//     // LOADING / MESSAGE
//     // =========================================================

//     const [loading, setLoading] = useState(false);

//     const [message, setMessage] = useState("");
//     const [messageType, setMessageType] = useState("");

//     // =========================================================
//     // LOGIN CHECK
//     // =========================================================

//     const [checkingLogin, setCheckingLogin] = useState(true);
//     const [isLoggedIn, setIsLoggedIn] = useState(false);

//     // =========================================================
//     // AUDITOR DATA
//     // =========================================================

//     const [auditorData, setAuditorData] = useState(null);

//     // =========================================================
//     // SURVEY DATA
//     // =========================================================

//     const [surveyList, setSurveyList] = useState([]);

//     // =========================================================
//     // CHECK EXISTING LOGIN
//     // =========================================================

//     useEffect(() => {

//         const checkExistingLogin = () => {

//             try {

//                 const storedAuditor =
//                     localStorage.getItem("surveyAuditor");

//                 if (storedAuditor) {

//                     const parsedAuditor =
//                         JSON.parse(storedAuditor);

//                     if (parsedAuditor) {

//                         console.log(
//                             "Already logged in auditor:",
//                             parsedAuditor
//                         );

//                         setAuditorData(parsedAuditor);
//                         setIsLoggedIn(true);

//                     } else {

//                         setIsLoggedIn(false);

//                     }

//                 } else {

//                     setIsLoggedIn(false);

//                 }

//             } catch (error) {

//                 console.error(
//                     "Error reading surveyAuditor:",
//                     error
//                 );

//                 localStorage.removeItem("surveyAuditor");

//                 setAuditorData(null);
//                 setIsLoggedIn(false);
//             }

//             setCheckingLogin(false);
//         };

//         checkExistingLogin();

//     }, []);

//     // =========================================================
//     // SIGNUP INPUT
//     // =========================================================

//     const handleSignupChange = (e) => {

//         const { name, value } = e.target;

//         setSignupData((prev) => ({
//             ...prev,
//             [name]: value,
//         }));
//     };

//     // =========================================================
//     // SIGNUP - SEND OTP
//     // =========================================================

//     const handleSignupSubmit = async (e) => {

//         e.preventDefault();

//         setMessage("");
//         setLoading(true);

//         try {

//             const email =
//                 signupData.email.trim().toLowerCase();

//             const result = await api.post(
//                 `${Config.local.site_api}/survey/createNewSurveyAuditor`,
//                 {
//                     name: signupData.name.trim(),
//                     email: email,
//                 }
//             );

//             console.log(
//                 "Signup OTP response:",
//                 result
//             );

//             if (
//                 result?.error === false &&
//                 result?.code === 200
//             ) {

//                 setSignupData((prev) => ({
//                     ...prev,
//                     email: email,
//                 }));

//                 setOtp("");

//                 setOtpType("signup");

//                 setShowOtp(true);

//                 setMessage(
//                     "OTP sent successfully to your email."
//                 );

//                 setMessageType("success");

//             } else {

//                 setMessage(
//                     result?.message ||
//                     "Unable to send OTP. Please try again."
//                 );

//                 setMessageType("error");
//             }

//         } catch (error) {

//             console.error(
//                 "Signup OTP error:",
//                 error
//             );

//             setMessage(
//                 error?.response?.data?.message ||
//                 error?.response?.message ||
//                 "Something went wrong while sending OTP."
//             );

//             setMessageType("error");

//         } finally {

//             setLoading(false);
//         }
//     };

//     // =========================================================
//     // LOGIN - SEND OTP
//     // =========================================================

//     const handleLoginSubmit = async (e) => {

//         e.preventDefault();

//         setMessage("");
//         setLoading(true);

//         try {

//             const email =
//                 loginIdentifier.trim().toLowerCase();

//             const result = await api.post(
//                 `${Config.local.site_api}/survey/sendOtpLoginSurveyAuditor`,
//                 {
//                     email: email,
//                 }
//             );

//             console.log(
//                 "Login OTP response:",
//                 result
//             );

//             if (
//                 result?.error === false &&
//                 result?.code === 200
//             ) {

//                 setLoginIdentifier(email);

//                 setOtp("");

//                 setOtpType("login");

//                 setShowOtp(true);

//                 setMessage(
//                     "OTP sent successfully to your email."
//                 );

//                 setMessageType("success");

//             } else {

//                 setMessage(
//                     result?.message ||
//                     "Unable to send OTP. Please check your email."
//                 );

//                 setMessageType("error");
//             }

//         } catch (error) {

//             console.error(
//                 "Login OTP error:",
//                 error
//             );

//             setMessage(
//                 error?.response?.data?.message ||
//                 error?.response?.message ||
//                 "Something went wrong while sending OTP."
//             );

//             setMessageType("error");

//         } finally {

//             setLoading(false);
//         }
//     };

//     // =========================================================
//     // OTP INPUT
//     // =========================================================

//     const handleOtpChange = (e) => {

//         const value =
//             e.target.value.replace(/\D/g, "");

//         if (value.length <= 6) {

//             setOtp(value);
//         }
//     };

//     // =========================================================
//     // VERIFY OTP
//     // =========================================================

//     const handleVerifyOtp = async (e) => {

//         e.preventDefault();

//         if (!otp || otp.length < 4) {

//             setMessage(
//                 "Please enter a valid OTP."
//             );

//             setMessageType("error");

//             return;
//         }

//         setMessage("");
//         setLoading(true);

//         try {

//             let result;

//             // =====================================================
//             // SIGNUP OTP VERIFICATION
//             // =====================================================

//             if (otpType === "signup") {

//                 result = await api.post(
//                     `${Config.local.site_api}/survey/verifyOtpForAuditorReg`,
//                     {
//                         name:
//                             signupData.name.trim(),

//                         email:
//                             signupData.email
//                                 .trim()
//                                 .toLowerCase(),

//                         otp: otp,
//                     }
//                 );

//                 console.log(
//                     "Signup OTP verification:",
//                     result
//                 );

//                 if (
//                     result?.error === false &&
//                     result?.code === 200
//                 ) {

//                     setMessage(
//                         result?.message ||
//                         "User registered successfully."
//                     );

//                     setMessageType("success");

//                     setShowOtp(false);

//                     setOtp("");

//                     // Move to login
//                     setActiveTab("login");

//                     setLoginIdentifier(
//                         signupData.email
//                     );

//                 } else {

//                     setMessage(
//                         result?.message ||
//                         "OTP verification failed."
//                     );

//                     setMessageType("error");
//                 }
//             }

//             // =====================================================
//             // LOGIN OTP VERIFICATION
//             // =====================================================

//             if (otpType === "login") {

//                 result = await api.post(
//                     `${Config.local.site_api}/survey/verifyOtpForAuditorLogin`,
//                     {
//                         email:
//                             loginIdentifier
//                                 .trim()
//                                 .toLowerCase(),

//                         otp: otp,
//                     }
//                 );

//                 console.log(
//                     "Login OTP verification:",
//                     result
//                 );

//                 // -------------------------------------------------
//                 // Your API response is currently using result.data
//                 // -------------------------------------------------

//                 if (
//                     result?.data?.error === false &&
//                     result?.data?.code === 200
//                 ) {

//                     const loggedInAuditor =
//                         result?.data?.data;

//                     console.log(
//                         "Logged in auditor:",
//                         loggedInAuditor
//                     );

//                     // =================================================
//                     // SAVE AUDITOR
//                     // =================================================

//                     localStorage.setItem(
//                         "surveyAuditor",
//                         JSON.stringify(
//                             loggedInAuditor
//                         )
//                     );

//                     // =================================================
//                     // UPDATE STATE
//                     // =================================================

//                     setAuditorData(
//                         loggedInAuditor
//                     );

//                     setIsLoggedIn(true);

//                     setShowOtp(false);

//                     setOtp("");

//                     setMessage("");

//                     setMessageType("");

//                 } else {

//                     setMessage(
//                         result?.data?.message ||
//                         "OTP verification failed."
//                     );

//                     setMessageType("error");
//                 }
//             }

//         } catch (error) {

//             console.error(
//                 "OTP verification error:",
//                 error
//             );

//             setMessage(
//                 error?.response?.data?.message ||
//                 error?.response?.message ||
//                 "Something went wrong while verifying OTP."
//             );

//             setMessageType("error");

//         } finally {

//             setLoading(false);
//         }
//     };

//     // =========================================================
//     // BACK FROM OTP
//     // =========================================================

//     const handleBackFromOtp = () => {

//         setShowOtp(false);

//         setOtp("");

//         setMessage("");

//         setMessageType("");
//     };

//     // =========================================================
//     // LOGOUT
//     // =========================================================

//     const handleLogout = () => {

//         localStorage.removeItem(
//             "surveyAuditor"
//         );

//         setAuditorData(null);

//         setIsLoggedIn(false);

//         setActiveTab("login");

//         setLoginIdentifier("");

//         setSignupData({
//             name: "",
//             email: "",
//         });

//         setSurveyList([]);

//         setMessage("");

//         setMessageType("");
//     };

//     // =========================================================
//     // GET AUDITOR NAME
//     // =========================================================

//     const getAuditorName = () => {

//         if (!auditorData) {
//             return "Auditor";
//         }

//         return (
//             auditorData?.name ||
//             auditorData?.first_name ||
//             auditorData?.firstName ||
//             auditorData?.auditorName ||
//             "Auditor"
//         );
//     };

//     // =========================================================
//     // LOGIN CHECK LOADING
//     // =========================================================

//     if (checkingLogin) {

//         return (
//             <>
//                 <section
//                     id="all-section"
//                     className="admin-header position-relative"
//                 >

//                     <nav
//                         className="navbar navbar-expand-lg bg-white p-0 border border-bottom"
//                         style={{
//                             height: "80px"
//                         }}
//                     >

//                         <div className="container-fluid">

//                             <a
//                                 className="navbar-brand1 logo-itemsw logoMain"
//                                 href="#"
//                             >

//                                 <img
//                                     src="../images/new-logo.png"
//                                     alt=""
//                                     style={{
//                                         height: "70px",
//                                         margin: "5px"
//                                     }}
//                                 />

//                             </a>

//                         </div>

//                     </nav>

//                 </section>

//                 <div className="survey-loading-screen">

//                     <div
//                         className="spinner-border"
//                         role="status"
//                     >
//                         <span className="visually-hidden">
//                             Loading...
//                         </span>
//                     </div>

//                 </div>

//                 <style>{`

//                     .survey-loading-screen {
//                         min-height: calc(100vh - 80px);
//                         display: flex;
//                         align-items: center;
//                         justify-content: center;
//                         background: #F7F9FB;
//                     }

//                 `}</style>
//             </>
//         );
//     }

//     // =========================================================
//     // =========================================================
//     // DASHBOARD
//     // IF ALREADY LOGIN
//     // =========================================================
//     // =========================================================

//     if (isLoggedIn) {

//         return (
//             <>
//                 {/* =====================================================
//                     HEADER
//                 ====================================================== */}

//                 <section
//                     id="all-section"
//                     className="admin-header position-relative"
//                 >

//                     <nav
//                         className="navbar navbar-expand-lg bg-white p-0 border border-bottom"
//                         style={{
//                             height: "80px"
//                         }}
//                     >

//                         <div className="container-fluid">

//                             {/* LOGO */}

//                             <a
//                                 className="navbar-brand1 logo-itemsw logoMain"
//                                 href="#"
//                             >

//                                 <img
//                                     src="../images/new-logo.png"
//                                     alt=""
//                                     style={{
//                                         height: "70px",
//                                         margin: "5px"
//                                     }}
//                                 />

//                             </a>


//                             {/* RIGHT SIDE */}

//                             <div
//                                 style={{
//                                     display: "flex",
//                                     alignItems: "center",
//                                     gap: "15px"
//                                 }}
//                             >

//                                 {/* Auditor Name */}

//                                 <div
//                                     style={{
//                                         display: "flex",
//                                         alignItems: "center",
//                                         gap: "8px"
//                                     }}
//                                 >

//                                     <div
//                                         className="auditor-profile-icon"
//                                     >
//                                         <i className="bi bi-person"></i>
//                                     </div>

//                                     <div>

//                                         <div
//                                             style={{
//                                                 fontSize: "12px",
//                                                 color: "#7C8794"
//                                             }}
//                                         >
//                                             Welcome
//                                         </div>

//                                         <div
//                                             style={{
//                                                 fontWeight: "700",
//                                                 fontSize: "14px"
//                                             }}
//                                         >
//                                             {getAuditorName()}
//                                         </div>

//                                     </div>

//                                 </div>


//                                 {/* Logout */}

//                                 <button
//                                     type="button"
//                                     className="auditor-logout-btn"
//                                     onClick={
//                                         handleLogout
//                                     }
//                                 >

//                                     <i className="bi bi-box-arrow-right"></i>

//                                     &nbsp;

//                                     Logout

//                                 </button>

//                             </div>

//                         </div>

//                     </nav>

//                 </section>


//                 {/* =====================================================
//                     DASHBOARD
//                 ====================================================== */}

//                 <div
//                     className="survey-dashboard-screen"
//                 >

//                     <div
//                         className="survey-dashboard-wrap"
//                     >

//                         {/* Heading */}

//                         <div
//                             className="survey-dashboard-header"
//                         >

//                             <div>

//                                 <h2>
//                                     Welcome, {getAuditorName()}
//                                 </h2>

//                                 <p>
//                                     Select a survey to start your audit.
//                                 </p>

//                             </div>

//                         </div>


//                         {/* =================================================
//                             SURVEY LIST
//                         ================================================== */}

//                         <div
//                             className="survey-dashboard-card"
//                         >

//                             {surveyList &&
//                             surveyList.length > 0 ? (

//                                 <div
//                                     className="survey-list"
//                                 >

//                                     {surveyList.map(
//                                         (survey, index) => (

//                                             <div
//                                                 className="survey-list-item"
//                                                 key={
//                                                     survey?._id ||
//                                                     survey?.surveyId ||
//                                                     index
//                                                 }
//                                             >

//                                                 <div>

//                                                     <h5>
//                                                         {
//                                                             survey?.surveyName ||
//                                                             survey?.name ||
//                                                             `Survey ${index + 1}`
//                                                         }
//                                                     </h5>

//                                                     <p>
//                                                         {
//                                                             survey?.description ||
//                                                             "Survey available for audit"
//                                                         }
//                                                     </p>

//                                                 </div>

//                                                 <button
//                                                     className="survey-btn-brand survey-view-btn"
//                                                     type="button"
//                                                 >

//                                                     View

//                                                     <i className="bi bi-arrow-right"></i>

//                                                 </button>

//                                             </div>

//                                         )
//                                     )}

//                                 </div>

//                             ) : (

//                                 <div
//                                     className="survey-empty-state"
//                                 >

//                                     <div
//                                         className="survey-empty-icon"
//                                     >

//                                         <i className="bi bi-clipboard-x"></i>

//                                     </div>

//                                     <h4>
//                                         No surveys available
//                                     </h4>

//                                     <p>
//                                         There are currently no surveys
//                                         assigned to you.
//                                     </p>

//                                 </div>

//                             )}

//                         </div>

//                     </div>

//                 </div>


//                 <style>{`

//                     :root {
//                         --orange: #FF7A33;
//                         --orange-dark: #E8611C;
//                         --orange-light: #FFF0E6;
//                         --sky: #0EA5E9;
//                         --sky-dark: #0284C7;
//                         --sky-light: #E4F6FF;
//                         --bg: #F7F9FB;
//                         --surface: #FFFFFF;
//                         --ink: #1F2733;
//                         --ink-muted: #7C8794;
//                         --border: #E9EEF2;
//                         --radius-lg: 20px;
//                         --radius-sm: 10px;
//                     }


//                     .survey-dashboard-screen {
//                         min-height: calc(100vh - 80px);

//                         background: var(--bg);

//                         background-image:
//                             radial-gradient(
//                                 60% 50% at 100% 0%,
//                                 rgba(14,165,233,0.08) 0%,
//                                 rgba(14,165,233,0) 60%
//                             ),
//                             radial-gradient(
//                                 50% 40% at 0% 100%,
//                                 rgba(255,122,51,0.08) 0%,
//                                 rgba(255,122,51,0) 60%
//                             );

//                         font-family: "Inter", sans-serif;

//                         color: var(--ink);
//                     }


//                     .survey-dashboard-wrap {
//                         max-width: 1100px;
//                         margin: 0 auto;
//                         padding: 45px 25px;
//                     }


//                     .survey-dashboard-header {
//                         display: flex;
//                         justify-content: space-between;
//                         align-items: center;
//                         margin-bottom: 25px;
//                     }


//                     .survey-dashboard-header h2 {
//                         margin: 0 0 5px;
//                         font-size: 28px;
//                         font-weight: 800;
//                     }


//                     .survey-dashboard-header p {
//                         margin: 0;
//                         color: var(--ink-muted);
//                     }


//                     .survey-dashboard-card {
//                         background: #fff;
//                         border: 1px solid var(--border);
//                         border-radius: 20px;
//                         padding: 25px;
//                         box-shadow:
//                             0 10px 30px -12px
//                             rgba(31,39,51,0.12);
//                     }


//                     .survey-list {
//                         display: flex;
//                         flex-direction: column;
//                         gap: 15px;
//                     }


//                     .survey-list-item {
//                         display: flex;
//                         justify-content: space-between;
//                         align-items: center;
//                         gap: 20px;

//                         padding: 20px;

//                         border: 1px solid var(--border);
//                         border-radius: 14px;

//                         background: #FCFDFE;
//                     }


//                     .survey-list-item h5 {
//                         margin: 0 0 5px;
//                         font-weight: 700;
//                     }


//                     .survey-list-item p {
//                         margin: 0;
//                         color: var(--ink-muted);
//                         font-size: 14px;
//                     }


//                     .survey-view-btn {
//                         width: auto;
//                         min-width: 100px;
//                     }


//                     .survey-empty-state {
//                         text-align: center;
//                         padding: 50px 20px;
//                     }


//                     .survey-empty-icon {
//                         width: 60px;
//                         height: 60px;

//                         margin: 0 auto 15px;

//                         border-radius: 16px;

//                         display: flex;
//                         align-items: center;
//                         justify-content: center;

//                         background: var(--orange-light);
//                         color: var(--orange-dark);

//                         font-size: 25px;
//                     }


//                     .survey-empty-state h4 {
//                         margin-bottom: 5px;
//                     }


//                     .survey-empty-state p {
//                         color: var(--ink-muted);
//                     }


//                     .auditor-profile-icon {
//                         width: 38px;
//                         height: 38px;

//                         border-radius: 50%;

//                         display: flex;
//                         align-items: center;
//                         justify-content: center;

//                         background: var(--sky-light);
//                         color: var(--sky-dark);
//                     }


//                     .auditor-logout-btn {
//                         border: 1px solid var(--border);
//                         background: #fff;

//                         color: var(--ink);

//                         border-radius: 8px;

//                         padding: 8px 14px;

//                         font-weight: 600;

//                         cursor: pointer;
//                     }


//                     .auditor-logout-btn:hover {
//                         background: #FEF2F2;
//                         color: #DC2626;
//                     }


//                     @media (max-width: 576px) {

//                         .survey-dashboard-wrap {
//                             padding: 25px 15px;
//                         }

//                         .survey-dashboard-header h2 {
//                             font-size: 22px;
//                         }

//                         .survey-list-item {
//                             flex-direction: column;
//                             align-items: flex-start;
//                         }

//                         .survey-view-btn {
//                             width: 100%;
//                         }

//                     }

//                 `}</style>
//             </>
//         );
//     }


//     // =========================================================
//     // =========================================================
//     // LOGIN / SIGNUP SCREEN
//     // =========================================================
//     // =========================================================

//     return (
//         <>

//             {/* =====================================================
//                 HEADER
//             ====================================================== */}

//             <section
//                 id="all-section"
//                 className="admin-header position-relative"
//             >

//                 <nav
//                     className="navbar navbar-expand-lg bg-white p-0 border border-bottom"
//                     style={{
//                         height: "80px"
//                     }}
//                 >

//                     <div className="container-fluid">

//                         <a
//                             className="navbar-brand1 logo-itemsw logoMain"
//                             href="#"
//                         >

//                             <img
//                                 src="../images/new-logo.png"
//                                 alt=""
//                                 style={{
//                                     height: "70px",
//                                     margin: "5px"
//                                 }}
//                             />

//                         </a>

//                         <ul
//                             className="navbar-nav flex-row align-items-center justify-contents-center w-auto"
//                         >
//                         </ul>

//                     </div>

//                 </nav>

//             </section>


//             {/* =====================================================
//                 AUTH SCREEN
//             ====================================================== */}

//             <div className="survey-auth-screen">

//                 <div className="survey-auth-wrap">

//                     <div className="survey-auth-topbar"></div>


//                     <div className="survey-auth-center">

//                         <div className="survey-auth-card">


//                             {/* =================================================
//                                 OTP SCREEN
//                             ================================================== */}

//                             {showOtp ? (

//                                 <div>

//                                     <div className="survey-otp-icon">

//                                         <i className="bi bi-shield-lock"></i>

//                                     </div>


//                                     <h2 className="survey-auth-title text-center">
//                                         Verify your email
//                                     </h2>


//                                     <p className="survey-auth-caption text-center">

//                                         Enter the OTP sent to

//                                         <br />

//                                         <strong>

//                                             {otpType === "signup"
//                                                 ? signupData.email
//                                                 : loginIdentifier}

//                                         </strong>

//                                     </p>


//                                     <form
//                                         onSubmit={
//                                             handleVerifyOtp
//                                         }
//                                     >

//                                         <div
//                                             className="survey-form-group last"
//                                         >

//                                             <label
//                                                 className="survey-form-label"
//                                             >
//                                                 Enter OTP
//                                             </label>


//                                             <input
//                                                 type="text"
//                                                 inputMode="numeric"
//                                                 maxLength={6}
//                                                 className="survey-form-control survey-otp-input"
//                                                 placeholder="Enter 6 digit OTP"
//                                                 value={otp}
//                                                 onChange={
//                                                     handleOtpChange
//                                                 }
//                                                 autoFocus
//                                                 required
//                                             />

//                                         </div>


//                                         <button
//                                             type="submit"
//                                             className="survey-btn-brand"
//                                             disabled={loading}
//                                         >

//                                             {loading ? (

//                                                 <>

//                                                     <span className="spinner-border spinner-border-sm"></span>

//                                                     Verifying...

//                                                 </>

//                                             ) : (

//                                                 <>

//                                                     Verify OTP

//                                                     <i className="bi bi-check-circle"></i>

//                                                 </>

//                                             )}

//                                         </button>

//                                     </form>


//                                     <button
//                                         type="button"
//                                         className="survey-back-btn"
//                                         onClick={
//                                             handleBackFromOtp
//                                         }
//                                     >

//                                         <i className="bi bi-arrow-left"></i>

//                                         &nbsp;

//                                         Back

//                                     </button>

//                                 </div>

//                             ) : (

//                                 <>

//                                     {/* =================================================
//                                         TABS
//                                     ================================================== */}

//                                     <div
//                                         className="survey-seg-tabs"
//                                     >

//                                         <button
//                                             type="button"
//                                             className={
//                                                 activeTab === "signup"
//                                                     ? "active"
//                                                     : ""
//                                             }
//                                             onClick={() => {

//                                                 setActiveTab(
//                                                     "signup"
//                                                 );

//                                                 setMessage("");

//                                             }}
//                                         >
//                                             Sign up
//                                         </button>


//                                         <button
//                                             type="button"
//                                             className={
//                                                 activeTab === "login"
//                                                     ? "active"
//                                                     : ""
//                                             }
//                                             onClick={() => {

//                                                 setActiveTab(
//                                                     "login"
//                                                 );

//                                                 setMessage("");

//                                             }}
//                                         >
//                                             Log in
//                                         </button>

//                                     </div>


//                                     {/* =================================================
//                                         MESSAGE
//                                     ================================================== */}

//                                     {message && (

//                                         <div
//                                             className={`survey-message ${
//                                                 messageType === "success"
//                                                     ? "success"
//                                                     : "error"
//                                             }`}
//                                         >

//                                             <i
//                                                 className={
//                                                     messageType === "success"
//                                                         ? "bi bi-check-circle"
//                                                         : "bi bi-exclamation-circle"
//                                                 }
//                                             ></i>


//                                             <span>
//                                                 {message}
//                                             </span>

//                                         </div>

//                                     )}


//                                     {/* =================================================
//                                         SIGN UP
//                                     ================================================== */}

//                                     {activeTab === "signup" && (

//                                         <div>

//                                             <h2 className="survey-auth-title">
//                                                 Create your account
//                                             </h2>


//                                             <p className="survey-auth-caption">
//                                                 Verify once, then access every survey assigned
//                                                 to you.
//                                             </p>


//                                             <form
//                                                 onSubmit={
//                                                     handleSignupSubmit
//                                                 }
//                                             >

//                                                 {/* NAME */}

//                                                 <div
//                                                     className="survey-form-group"
//                                                 >

//                                                     <label
//                                                         className="survey-form-label"
//                                                     >
//                                                         Auditor name
//                                                     </label>


//                                                     <div
//                                                         className="survey-input-icon-group"
//                                                     >

//                                                         <i className="bi bi-person"></i>


//                                                         <input
//                                                             type="text"
//                                                             name="name"
//                                                             className="survey-form-control"
//                                                             placeholder="e.g. Aditi Sharma"
//                                                             value={
//                                                                 signupData.name
//                                                             }
//                                                             onChange={
//                                                                 handleSignupChange
//                                                             }
//                                                             required
//                                                         />

//                                                     </div>

//                                                 </div>


//                                                 {/* EMAIL */}

//                                                 <div
//                                                     className="survey-form-group last"
//                                                 >

//                                                     <label
//                                                         className="survey-form-label"
//                                                     >
//                                                         Email ID
//                                                     </label>


//                                                     <div
//                                                         className="survey-input-icon-group"
//                                                     >

//                                                         <i className="bi bi-envelope"></i>


//                                                         <input
//                                                             type="email"
//                                                             name="email"
//                                                             className="survey-form-control"
//                                                             placeholder="you@example.com"
//                                                             value={
//                                                                 signupData.email
//                                                             }
//                                                             onChange={
//                                                                 handleSignupChange
//                                                             }
//                                                             required
//                                                         />

//                                                     </div>

//                                                 </div>


//                                                 <button
//                                                     type="submit"
//                                                     className="survey-btn-brand"
//                                                     disabled={
//                                                         loading
//                                                     }
//                                                 >

//                                                     {loading ? (

//                                                         <>

//                                                             <span className="spinner-border spinner-border-sm"></span>

//                                                             Sending OTP...

//                                                         </>

//                                                     ) : (

//                                                         <>

//                                                             Send verification OTP

//                                                             <i className="bi bi-arrow-right"></i>

//                                                         </>

//                                                     )}

//                                                 </button>


//                                                 <p className="survey-helper-text">
//                                                     We'll email a one-time code to confirm
//                                                     it's really you.
//                                                 </p>

//                                             </form>

//                                         </div>

//                                     )}


//                                     {/* =================================================
//                                         LOGIN
//                                     ================================================== */}

//                                     {activeTab === "login" && (

//                                         <div>

//                                             <h2 className="survey-auth-title">
//                                                 Welcome back
//                                             </h2>


//                                             <p className="survey-auth-caption">
//                                                 Log in with a one-time code — no password needed.
//                                             </p>


//                                             <form
//                                                 onSubmit={
//                                                     handleLoginSubmit
//                                                 }
//                                             >

//                                                 <div
//                                                     className="survey-form-group last"
//                                                 >

//                                                     <label
//                                                         className="survey-form-label"
//                                                     >
//                                                         Email
//                                                     </label>


//                                                     <div
//                                                         className="survey-input-icon-group"
//                                                     >

//                                                         <i className="bi bi-envelope"></i>


//                                                         <input
//                                                             type="email"
//                                                             className="survey-form-control"
//                                                             placeholder="you@example.com"
//                                                             value={
//                                                                 loginIdentifier
//                                                             }
//                                                             onChange={(e) =>
//                                                                 setLoginIdentifier(
//                                                                     e.target.value
//                                                                 )
//                                                             }
//                                                             required
//                                                         />

//                                                     </div>

//                                                 </div>


//                                                 <button
//                                                     type="submit"
//                                                     className="survey-btn-brand"
//                                                     disabled={
//                                                         loading
//                                                     }
//                                                 >

//                                                     {loading ? (

//                                                         <>

//                                                             <span className="spinner-border spinner-border-sm"></span>

//                                                             Sending OTP...

//                                                         </>

//                                                     ) : (

//                                                         <>

//                                                             Send OTP

//                                                             <i className="bi bi-arrow-right"></i>

//                                                         </>

//                                                     )}

//                                                 </button>

//                                             </form>


//                                             <div
//                                                 className="survey-divider"
//                                             >
//                                                 new here
//                                             </div>


//                                             <button
//                                                 type="button"
//                                                 className="survey-btn-sky"
//                                                 onClick={() => {

//                                                     setActiveTab(
//                                                         "signup"
//                                                     );

//                                                     setMessage("");

//                                                 }}
//                                             >

//                                                 <i className="bi bi-person-plus"></i>

//                                                 &nbsp;

//                                                 Create a Auditor account

//                                             </button>

//                                         </div>

//                                     )}

//                                 </>

//                             )}

//                         </div>

//                     </div>

//                 </div>

//             </div>


//             {/* =====================================================
//                 CSS
//             ====================================================== */}

//             <style>{`

//                 :root {
//                     --orange: #FF7A33;
//                     --orange-dark: #E8611C;
//                     --orange-light: #FFF0E6;

//                     --sky: #0EA5E9;
//                     --sky-dark: #0284C7;
//                     --sky-light: #E4F6FF;

//                     --bg: #F7F9FB;
//                     --surface: #FFFFFF;

//                     --ink: #1F2733;
//                     --ink-muted: #7C8794;

//                     --border: #E9EEF2;

//                     --radius-lg: 20px;
//                     --radius-sm: 10px;

//                     --shadow-soft:
//                         0 10px 30px -12px
//                         rgba(31, 39, 51, 0.12);
//                 }


//                 .survey-auth-screen {
//                     min-height: calc(100vh - 80px);

//                     background: var(--bg);

//                     background-image:
//                         radial-gradient(
//                             60% 50% at 100% 0%,
//                             rgba(14,165,233,0.08) 0%,
//                             rgba(14,165,233,0) 60%
//                         ),

//                         radial-gradient(
//                             50% 40% at 0% 100%,
//                             rgba(255,122,51,0.08) 0%,
//                             rgba(255,122,51,0) 60%
//                         );

//                     background-attachment: fixed;

//                     font-family: "Inter", sans-serif;

//                     color: var(--ink);
//                 }


//                 .survey-auth-screen *,
//                 .survey-auth-screen *::before,
//                 .survey-auth-screen *::after {
//                     box-sizing: border-box;
//                 }


//                 .survey-auth-screen h1,
//                 .survey-auth-screen h2,
//                 .survey-auth-screen h3,
//                 .survey-auth-screen h4,
//                 .survey-auth-screen h5 {
//                     font-family:
//                         "Plus Jakarta Sans",
//                         sans-serif;
//                 }


//                 .survey-auth-wrap {
//                     min-height:
//                         calc(100vh - 80px);

//                     display: flex;

//                     flex-direction: column;
//                 }


//                 .survey-auth-topbar {
//                     padding:
//                         20px
//                         clamp(20px, 5vw, 64px)
//                         0;
//                 }


//                 .survey-auth-center {
//                     flex: 1;

//                     display: flex;

//                     align-items: center;

//                     justify-content: center;

//                     padding: 24px;
//                 }


//                 .survey-auth-card {
//                     width: 100%;

//                     max-width: 440px;

//                     padding:
//                         clamp(28px, 4vw, 44px);

//                     background:
//                         var(--surface);

//                     border:
//                         1px solid var(--border);

//                     border-radius:
//                         var(--radius-lg);

//                     box-shadow:
//                         var(--shadow-soft);
//                 }


//                 /* TABS */

//                 .survey-seg-tabs {
//                     display: flex;

//                     background:
//                         var(--bg);

//                     border:
//                         1px solid var(--border);

//                     border-radius:
//                         999px;

//                     padding: 4px;

//                     margin-bottom: 28px;
//                 }


//                 .survey-seg-tabs button {
//                     flex: 1;

//                     border: 0;

//                     background: transparent;

//                     padding: 9px 0;

//                     border-radius:
//                         999px;

//                     font-weight: 600;

//                     font-size: 0.92rem;

//                     color:
//                         var(--ink-muted);

//                     transition: 0.2s;

//                     cursor: pointer;
//                 }


//                 .survey-seg-tabs button.active {
//                     background:
//                         var(--surface);

//                     color:
//                         var(--ink);

//                     box-shadow:
//                         0 4px 12px
//                         rgba(31,39,51,0.08);
//                 }


//                 /* TEXT */

//                 .survey-auth-title {
//                     font-size: 1.5rem;

//                     font-weight: 800;

//                     margin:
//                         0 0 6px;
//                 }


//                 .survey-auth-caption {
//                     color:
//                         var(--ink-muted);

//                     font-size: 0.95rem;

//                     margin-bottom: 24px;
//                 }


//                 /* FORM */

//                 .survey-form-group {
//                     margin-bottom: 16px;
//                 }


//                 .survey-form-group.last {
//                     margin-bottom: 24px;
//                 }


//                 .survey-form-label {
//                     display: block;

//                     font-weight: 600;

//                     font-size: 0.85rem;

//                     color:
//                         var(--ink);

//                     margin-bottom: 6px;
//                 }


//                 .survey-input-icon-group {
//                     position: relative;
//                 }


//                 .survey-input-icon-group i {
//                     position: absolute;

//                     left: 14px;

//                     top: 50%;

//                     transform:
//                         translateY(-50%);

//                     color:
//                         var(--ink-muted);

//                     font-size: 1rem;

//                     pointer-events: none;
//                 }


//                 .survey-form-control {
//                     width: 100%;

//                     border-radius:
//                         var(--radius-sm);

//                     border:
//                         1.5px solid
//                         var(--border);

//                     padding:
//                         0.65rem
//                         0.9rem
//                         0.65rem
//                         40px;

//                     font-size: 0.95rem;

//                     background:
//                         #FCFDFE;

//                     color:
//                         var(--ink);

//                     outline: none;
//                 }


//                 .survey-form-control:focus {
//                     border-color:
//                         var(--sky);

//                     box-shadow:
//                         0 0 0 4px
//                         var(--sky-light);

//                     background:
//                         #fff;
//                 }


//                 /* BUTTON */

//                 .survey-btn-brand {
//                     width: 100%;

//                     border: 0;

//                     background:
//                         linear-gradient(
//                             135deg,
//                             var(--orange),
//                             var(--orange-dark)
//                         );

//                     color: #fff;

//                     font-weight: 700;

//                     border-radius:
//                         var(--radius-sm);

//                     padding:
//                         0.7rem 1rem;

//                     box-shadow:
//                         0 8px 18px -6px
//                         rgba(255,122,51,0.55);

//                     transition:
//                         transform 0.15s ease,
//                         box-shadow 0.15s ease;

//                     cursor: pointer;

//                     display: flex;

//                     align-items: center;

//                     justify-content: center;

//                     gap: 8px;
//                 }


//                 .survey-btn-brand:hover {
//                     transform:
//                         translateY(-1px);

//                     box-shadow:
//                         0 10px 22px -6px
//                         rgba(255,122,51,0.65);
//                 }


//                 .survey-btn-brand:disabled {
//                     opacity: 0.55;

//                     transform: none;

//                     box-shadow: none;

//                     cursor:
//                         not-allowed;
//                 }


//                 /* BLUE BUTTON */

//                 .survey-btn-sky {
//                     width: 100%;

//                     background:
//                         var(--sky-light);

//                     border:
//                         1.5px solid transparent;

//                     color:
//                         var(--sky-dark);

//                     font-weight: 700;

//                     border-radius:
//                         var(--radius-sm);

//                     padding:
//                         0.55rem 1rem;

//                     cursor: pointer;
//                 }


//                 .survey-btn-sky:hover {
//                     background:
//                         #d5f0ff;

//                     color:
//                         var(--sky-dark);
//                 }


//                 /* DIVIDER */

//                 .survey-divider {
//                     display: flex;

//                     align-items: center;

//                     gap: 10px;

//                     color:
//                         var(--ink-muted);

//                     font-size: 0.78rem;

//                     margin:
//                         18px 0;
//                 }


//                 .survey-divider::before,
//                 .survey-divider::after {
//                     content: "";

//                     flex: 1;

//                     height: 1px;

//                     background:
//                         var(--border);
//                 }


//                 /* HELPER */

//                 .survey-helper-text {
//                     text-align: center;

//                     margin-top: 12px;

//                     margin-bottom: 0;

//                     font-size: 0.82rem;

//                     color:
//                         var(--ink-muted);

//                     line-height: 1.5;
//                 }


//                 /* OTP */

//                 .survey-otp-icon {
//                     width: 56px;

//                     height: 56px;

//                     border-radius: 16px;

//                     background:
//                         var(--orange-light);

//                     color:
//                         var(--orange-dark);

//                     display: flex;

//                     align-items: center;

//                     justify-content: center;

//                     margin:
//                         0 auto 20px;

//                     font-size: 1.5rem;
//                 }


//                 .survey-otp-input {
//                     padding-left: 12px;

//                     text-align: center;

//                     font-size: 1.4rem;

//                     font-weight: 700;

//                     letter-spacing: 8px;
//                 }


//                 .survey-back-btn {
//                     display: block;

//                     margin:
//                         18px auto 0;

//                     border: 0;

//                     background: transparent;

//                     color:
//                         var(--sky-dark);

//                     font-weight: 600;

//                     cursor: pointer;
//                 }


//                 .survey-back-btn:hover {
//                     color:
//                         var(--sky);
//                 }


//                 /* MESSAGE */

//                 .survey-message {
//                     display: flex;

//                     align-items: center;

//                     gap: 8px;

//                     border-radius: 10px;

//                     padding: 10px 12px;

//                     margin-bottom: 18px;

//                     font-size: 0.85rem;

//                     font-weight: 600;
//                 }


//                 .survey-message.success {
//                     background:
//                         #E9FBF0;

//                     color:
//                         #15803D;

//                     border:
//                         1px solid
//                         #BBF7D0;
//                 }


//                 .survey-message.error {
//                     background:
//                         #FEF2F2;

//                     color:
//                         #DC2626;

//                     border:
//                         1px solid
//                         #FECACA;
//                 }


//                 .survey-btn-brand
//                 .spinner-border {
//                     width: 16px;

//                     height: 16px;

//                     border-width: 2px;
//                 }


//                 /* MOBILE */

//                 @media (max-width: 576px) {

//                     .survey-auth-center {
//                         padding: 16px;

//                         align-items:
//                             flex-start;

//                         padding-top: 30px;
//                     }


//                     .survey-auth-card {
//                         padding:
//                             24px 20px;
//                     }


//                     .survey-otp-input {
//                         letter-spacing: 5px;
//                     }

//                 }

//             `}</style>

//         </>
//     );
// };

// export default LoginSignupForSurveyAttempt;